import * as Types from './types';

export const STACK: Types.ISocketStackEntry[] = [];

export const SEND_SYMBOL = Symbol('send');

export const BATCH_REQUEST_ID = 35508;

// region Cashier

export enum CASHIER_TYPE {
    DEPOSIT = 'deposit',
    WITHDRAWAL = 'withdraw'
}

export enum CASHIER_FIELD_TYPE {
    DROPDOWN = 'dropdown',
    CHECKBOX = 'checkbox',
    COUNTRY = 'country',
    ENCRYPTED = 'sensitive',
    EXP_DATE = 'yearAndMonth',
    PASSWORD = 'password',
    PHONE = 'phone',
    RADIO = 'radiobuttons',
    TEXT = 'regular',
}

export enum PAYMENT_METHODS_CODES {
    APPLE_PAY_EPG = 'ApplePayEPG',
    DOTPAY_BANK_TRANSFER = 'DotpayBankTransfer',
    DOTPAY_BLIK = 'DotpayBlik',
    DOTPAY_CARD = 'DotpayCard',
    EASYCC = 'EasyCC',
    NUVEI_CC = 'CC',
    PAYPAL_VIA_SC = 'PayPalViaSC',
    PRAXIS = 'PraxisCard'
}

export enum CASHIER_REDIRECT_TYPE {
    APPLE_PAY_EPG = 'applepayepg',
    IFRAME = 'iframe',
    JS_EASY_PG = 'jseasypg',
    JS_NUVEI = 'jsnuvei',
    JS_PAY_SAFE = 'jspaysafe',
    LIGHT_BOX = 'lightboxdt',
    LIGHT_BOX_JSON = 'lightboxdtjson',
    POPUP = 'popup',
    PRAXIS = 'jspraxis',
    REDIRECT = 'redirect',
    SEAMLESS_WC = 'seamlesswc'
}

// endregion

// region other

export const IGNORE_LIMITS_NOTIFICATION = 'ignore-limits-notification';

// endregion
